import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import {
  fetchCurrentUserFollowing,
  selectCurrentUser,
} from 'features/auth/slice';

import {
  Heading,
  Loader,
  LoadMore,
  recordsMatch,
} from '@frontendmentorio/design-system-v2';

import Banner from './UserBanner';
import CommentCardWithSolution from 'features/comments/CardWithSolution';
import CommentsEmptyState from './CommentsEmptyState';

export default function Comments({ user }) {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const isCurrentUser = recordsMatch(currentUser, user);

  const {
    data: { data: comments, meta },
    isLoading,
    setPage,
  } = useFetchInfinite(
    isCurrentUser
      ? '/api/v3/learner/comments'
      : `/api/v3/learners/${user.id}/comments`
  );

  useEffect(() => {
    if (!currentUser || isCurrentUser) return;

    dispatch(fetchCurrentUserFollowing());
  }, [currentUser, isCurrentUser]);

  return (
    <>
      {!isCurrentUser && <Banner user={user} />}

      <div className="pt-7 px-5 py-6">
        <div className="container-md flex flex-col gap-6 items-center">
          <Heading level="2" tagName="h1">
            All comments
          </Heading>

          {comments?.length > 0 ? (
            <>
              <ul className="flex flex-col gap-5 w-full">
                {comments.map((comment) => (
                  <CommentCardWithSolution comment={comment} key={comment.id} />
                ))}
              </ul>

              {meta?.page.next && (
                <LoadMore
                  isLoading={isLoading}
                  onClick={() => setPage(meta.page.next)}
                />
              )}
            </>
          ) : isLoading ? (
            <Loader className="py-10" />
          ) : (
            <CommentsEmptyState isCurrentUser={isCurrentUser} />
          )}
        </div>
      </div>
    </>
  );
}
